export default __webpack_public_path__ + "static/media/loginlogofurnish.97541f5f.png";